var React  = require('react');
var connect = require('react-redux').connect;

var {changeSection, closeWelcome} = require('../actions/welcome');

var Benefits = require('./benefits');
var ModalDialog    = require('patternity/lib/modal_dialog');
var Profile = require('./profile');

var Welcome = React.createClass({
  propTypes: {
    showOnboarding: React.PropTypes.bool.isRequired,
    firstTime: React.PropTypes.bool.isRequired,
    onBoarding: React.PropTypes.func.isRequired,
    isOpen:  React.PropTypes.bool.isRequired,
    selectedSection: React.PropTypes.string.isRequired,
    contact: React.PropTypes.object.isRequired,
    csrfToken: React.PropTypes.string.isRequired,
    analytics: React.PropTypes.object.isRequired,
    isMobile: React.PropTypes.bool.isRequired,
    supportedLanguages: React.PropTypes.array
  },

  componentDidMount: function () {
    if(this.props.showOnboarding) {
      this._removeWelcomeFromHistory();
    }
  },

  render: function() {
    if(!this.props.showOnboarding || !this.props.isOpen) {
      return null;
    }

    return (
      <ModalDialog isModalOpen={true} size="large" ref="welcomeModal" closeable={false}>
        <ModalDialog.Body ref="modalBody">

          {this._renderSection()}

        </ModalDialog.Body>
      </ModalDialog>
    );
  },

  _renderSection: function() {
    if(this.props.selectedSection === "benefits") {
      return (
        <Benefits
          onSectionChange={this._onSectionChange}
          dispatch={this.props.dispatch}
          isMobile={this.props.isMobile}
          onCloseDialog={this._closeDialog} />
      )
    }

    return (
      <Profile
        onCloseDialog={this._closeDialog}
        csrfToken={this.props.csrfToken}
        dispatch={this.props.dispatch}
        contact={this.props.contact}
        supportedLanguages={this.props.supportedLanguages}
        analytics={this.props.analytics} />
    )
  },

  _closeDialog: function () {
    if (window.parent.location.href === window.location.href) {
      this.props.dispatch(closeWelcome());
      this._firstTime();
    } else {
      window.parent.postMessage("hide_onboarding_modal", '*');
    }
  },

  _onSectionChange: function(section) {
    this.props.dispatch(changeSection(section));
  },

  _firstTime: function() {
    if(this.props.firstTime) {
      this.props.onBoarding('/#onboarding/choose');
    }
  },

  _removeWelcomeFromHistory: function() {
    window.history.replaceState({}, '/?welcome=true', window.location.pathname);
  }
});

module.exports = connect(function(state) {
  return state.welcome;
})(Welcome);



// WEBPACK FOOTER //
// ./src/advocate/onboarding/containers/welcome.jsx